import { render, staticRenderFns } from "./LeaveSettingLayout.vue?vue&type=template&id=1e48469e&scoped=true&"
import script from "./LeaveSettingLayout.vue?vue&type=script&lang=js&"
export * from "./LeaveSettingLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e48469e",
  null
  
)

export default component.exports